import { GameId } from '@bg-shared/enums/GameId';
import { DEFAULT_ROULETTE_NEIGHBOR_COUNT } from '@bg-shared/constants/constants';
import { IPlayerSettingsModel } from './interfaces';

export const playerSettingsSelectors = {
    getCasinoMode: (state: IPlayerSettingsModel) => state.casino.enabled,

    getGuiMode: (state: IPlayerSettingsModel) => state.gui.enabled,

    getOddsFormat: (state: IPlayerSettingsModel) => state.oddsFormat,

    getOnlyRngAnimationsEnabled: (state: IPlayerSettingsModel) => state.onlyRngAnimations,

    getAutoShowRouletteStatistics: (state: IPlayerSettingsModel) =>
        state.autoShowRouletteStatistics,

    getVodOptions: (gameId: GameId) => (state: IPlayerSettingsModel) => ({
        dealerLanguage: state.selectedVODByGame?.[gameId]?.language ?? null,
        dealer: state.selectedVODByGame?.[gameId]?.dealer ?? null,
    }),

    getRouletteNeighbourCount: (state: IPlayerSettingsModel) =>
        state.rouletteNeighbourCount ?? DEFAULT_ROULETTE_NEIGHBOR_COUNT,
};
